<template>
  <div class="directions">
    <h1>This is the directions page</h1>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
